import styled from 'styled-components'
import variables from '../../styles/variables'
import knowledgeGardenBg from '../../../assets/knowledge_garden_with_river.png'

export const Container = styled.section`
  width: 100%;
  background: ${variables.colors.brandPrimary};
  background-image: url(${knowledgeGardenBg});
  background-position: right center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
  position: relative;
  overflow: hidden;
  
  /* Variant-specific padding */
  ${props => props.variant === 'compact' && `
    padding: 72px 0;
    
    @media ${variables.media.sm} {
      padding: 120px 0;
    }
  `}
  
  ${props => props.variant === 'default' && `
    padding: 72px 0;
    
    @media ${variables.media.sm} {
      padding: 120px 0;
    }
  `}
  
  ${props => props.variant === 'wide' && `
    padding: 96px 0;
    
    @media ${variables.media.sm} {
      padding: 140px 0;
    }
  `}
  
  /* Dark overlay for better text readability */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(12, 11, 40, 0.3);
    z-index: 1;
  }
`

export const ContentWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
  
  /* Text alignment */
  text-align: ${props => props.textAlign || 'center'};
  
  /* Mobile adjustments */
  @media (max-width: 768px) {
    text-align: center;
    padding: 0 1rem;
  }
  
  /* Typography styles for children */
  h1, h2, h3, h4, h5, h6 {
    color: white;
    word-spacing: normal;
  }
  
  h1 {
    font-size: 3.5rem;
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: -0.5px;
    margin-bottom: 1.5rem;
    
    @media (max-width: 768px) {
      font-size: 2.5rem;
      line-height: 1.18;
    }
  }
  
  h2 {
    font-size: 2.5rem;
    font-weight: 600;
    line-height: 1.15;
    letter-spacing: -0.3px;
    margin-bottom: 1.25rem;
    
    @media (max-width: 768px) {
      font-size: 2rem;
      line-height: 1.2;
    }
  }
  
  h3 {
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 1.3;
    margin-bottom: 1rem;
  }
  
  p {
    color: ${variables.colors.greyLightest};
    font-size: 1.2rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
    max-width: 700px;
    
    ${props => props.textAlign === 'center' && `
      margin-left: auto;
      margin-right: auto;
    `}
    
    @media (max-width: 768px) {
      font-size: 1.1rem;
      margin-left: auto;
      margin-right: auto;
    }
  }
  
  /* Button styling within the section */
  .button, button {
    background: ${variables.colors.turquoiseAccent};
    color: white;
    border: none;
    padding: 1rem 2rem;
    border-radius: 6px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: ${variables.colors.turquoiseAccent};
      transform: translateY(-2px);
    }
  }
  
  /* Outline button variant */
  .button--outline {
    background: transparent;
    color: ${variables.colors.turquoiseAccent};
    border: 2px solid ${variables.colors.turquoiseAccent};
    
    &:hover {
      background: ${variables.colors.turquoiseAccent};
      color: white;
    }
  }
`